
import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Company } from '../../types';
import { firestoreService } from '../../services/firestoreService';
import Spinner from '../../components/common/Spinner';
import { AuthContext } from '../../contexts/AuthContext';

const FilterIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" /></svg>;

const FiltersPage: React.FC = () => {
    const [companies, setCompanies] = useState<Company[]>([]);
    const [loading, setLoading] = useState(true);
    const authContext = useContext(AuthContext);

    useEffect(() => {
        const fetchCompanies = async () => {
            setLoading(true);
            // Fixed: Added tenantId to getCompanies call
            const tenantId = authContext?.user?.tenantId;
            if (tenantId) {
                const fetchedCompanies = await firestoreService.getCompanies(tenantId);
                setCompanies(fetchedCompanies);
            }
            setLoading(false);
        };
        fetchCompanies();
    }, [authContext?.user?.tenantId]);

    if (loading) {
        return <div className="flex justify-center items-center h-full"><Spinner size="lg" /></div>;
    }

    return (
        <div className="container mx-auto">
            <h1 className="text-3xl font-bold text-white mb-6">Manage Filters by Company</h1>
            <p className="text-gray-400 mb-8">Select a company to view, add, or edit its custom filters. These filters will be available when uploading new videos for that company.</p>

            <div className="bg-gray-900 rounded-lg shadow-lg overflow-hidden">
                <table className="min-w-full">
                    <thead className="bg-gray-800/50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Company Name</th>
                            <th className="px-6 py-3 text-right text-xs font-medium text-gray-300 uppercase tracking-wider">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-800">
                        {companies.map((company) => (
                            <tr key={company.companyId} className="hover:bg-gray-800/40 transition-colors">
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-white">{company.name}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                    <Link 
                                        to={`/filters/${company.companyId}`} 
                                        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 focus:ring-blue-500"
                                    >
                                        <FilterIcon />
                                        Manage Filters
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default FiltersPage;
